<template lang="pug">
    section#blogFael(@mouseenter="stopAutoPlay", @mouseleave="startAutoPlay")
        .wrapper
            h3
                router-link(:to="{name: 'noticias'}") Blog UniFael
            button(@click="toggleGaleria(noticiaAtiva - 1)", :disabled="scrolling").seta.left
                img(:src="require('@images/icones/setaGaleria.png')")
            button(@click="toggleGaleria(noticiaAtiva + 1)", :disabled="scrolling").seta.right
                img(:src="require('@images/icones/setaGaleria.png')")
        .galeria(:style="style", ref="galeria")
            .noticia.previous(v-for="noticia, index in previousNoticias")
                router-link(:to="{name: 'noticia', params: { slug: noticia.slug }}")
                    div.img
                        img(:src="noticia.thumb_link", :alt="noticia.titulo")
                    div.conteudo
                        h4(:title="noticia.titulo") {{ noticia.titulo | encurtador }}
                        p(:title="noticia.resumo") {{ noticia.resumo | encurtador(51) }}
            .noticia(v-for="noticia, index in noticias", :class="{ ativo: noticiaAtiva == index }")
                router-link(:to="{name: 'noticia', params: { slug: noticia.slug }}")
                    div.img
                        img(:src="noticia.thumb_link", :alt="noticia.titulo")
                    div.conteudo
                        h4(:title="noticia.titulo") {{ noticia.titulo | encurtador }}
                        p(:title="noticia.resumo") {{ noticia.resumo | encurtador(51) }}
            .noticia.next(v-for="noticia, index in nextNoticias")
                router-link(:to="{name: 'noticia', params: { slug: noticia.slug }}")
                    div.img
                        img(:src="noticia.thumb_link", :alt="noticia.titulo")
                    div.conteudo
                        h4(:title="noticia.titulo") {{ noticia.titulo | encurtador }}
                        p(:title="noticia.resumo") {{ noticia.resumo | encurtador(51) }}

        router-link(:to="{name: 'noticias'}").verTodos ver todas as matérias do blog
</template>

<script>
import qs from 'qs'

export default {
    name: "component-blog-fael",
    data() {
        return {
            noticias: [],
            noticiaAtiva: 0,
            style: {
                transform: `translateX(0)`,
                transition: `all .5s ease`
            },
            autoplay: null,
            scrolling: false,
            params: {
                limit: 5,
                sort: '-published_at',
            }
        }
    },
    created() {
        this.loadNoticias();
    },
    filters: {
        encurtador(valor, tamanho = 45) {
            if (valor.length >= tamanho)
                return valor.slice(0, tamanho - 6) + ' [...]'
            return valor
        }
    },
    computed: {
        nextNoticias() {
            if (this.noticias.length)
                return this.noticias.slice(0, 3)
            return []
        },
        previousNoticias() {
            if (this.noticias.length)
                return this.noticias.slice(this.noticias.length - 3, this.noticias.length)
            return []
        },
    },
    methods: {
        startAutoPlay() {
            this.autoplay = setTimeout(this.autoplayLoop, 3500)
        },
        stopAutoPlay() {
            clearTimeout(this.autoplay)
        },
        autoplayLoop() {
            this.toggleGaleria(this.noticiaAtiva + 1)
            this.autoplay = setTimeout(this.autoplayLoop, 3500)
        },
        loadNoticias() {
            this.$axios
                .get(`noticias?${qs.stringify(this.params)}`)
                .then(response => this.noticias = response.data.data)
                .then(() => setTimeout(() => this.style.transform = `translateX(-${this.toScroll(0)}px)`, 1))
                .then(this.startAutoPlay)
                .catch(() => this.noticias = [])
        },
        toggleGaleria(index) {
            this.scrolling = true
            this.style.transform = `translateX(-${this.toScroll(index)}px)`

            if (index >= this.noticias.length) {
                setTimeout(() => this.style.transition = `none`, 600)
                setTimeout(() => this.style.transform = `translateX(-${this.toScroll(0)}px)`, 650)
                setTimeout(() => this.style.transition = `all .5s ease`, 700)
                setTimeout(() => this.scrolling = false, 700)
                this.noticiaAtiva = 0
            } else if (index < 0) {
                setTimeout(() => this.style.transition = `none`, 600)
                setTimeout(() => this.style.transform = `translateX(-${this.toScroll(this.noticias.length - 1)}px)`, 650)
                setTimeout(() => this.style.transition = `all .5s ease`, 700)
                setTimeout(() => this.scrolling = false, 700)
                this.noticiaAtiva = this.noticias.length - 1
            } else {
                this.noticiaAtiva = index
                this.scrolling = false
            }
        },
        toScroll(index) {
            let noticiaWidth = this.$refs.galeria.querySelector(`.noticia`).offsetWidth
            let screenWidth = window.innerWidth
            return ((Number(noticiaWidth) * this.previousNoticias.length) + (Number(noticiaWidth) * index)) - ((screenWidth - noticiaWidth) / 2)
        }
    }
}
</script>

<style lang="stylus" scoped src="./BlogFael.styl"></style>
